module.exports = __webpack_public_path__ + "static/media/DSC_7162.63b80acb.jpg";